<template>
  <div style="padding-bottom:20px;background-color: #F7E1BC;">

    <div class="zjb_configShareTitle">
      包包变脏不敢背出门？<br>
      别担心！<br>
      被包大人施展「洗护魔法」后，<br>
      再脏的包包都能崭新如初~<br>
      （结尾还有闯关小游戏噢）<br>
      👇👇
    </div>

    <div class="zjb_configShareImgBox">
      <img src="https://img.chenzhen.shop/2022/03/16/ac7d8b0d-9d6c-49a4-9117-b5101a68ab71.jpg"/>
      <img src="https://img.chenzhen.shop/2022/03/16/cf2f0a64-774f-4ecc-bbdb-239a98ad37a0.jpg"/>
      <img src="https://img.chenzhen.shop/2022/03/16/b64d7158-d341-4444-84f7-bb67ef1f32c2.jpg"/>
    </div>

    <div class="zjb_configShareTitle2">
      我是「养护界」魔法师·包大人🧙🏻<br>
      解决疑难杂症是我的王牌技能<br>
      致力于守护每一件心爱之物<br>
      如果你也有需要，随时来找我<br>
      ❤️
    </div>

    <iframe class="zjb_iframe" src="static/html5-puzzle/index.html"></iframe>

    <div class="configShare_bottom">
      <button class="configShare_kefuBtn" @click="toKefu">联系客服</button>
    </div>
    

  </div>
</template>

<script>
import wxShare from "@/assets/js/wx.share"
import zhugeObj from '@/assets/js/track'
export default {
  name: 'bagGameIndex',

  data() {
    return {
      
    }
  },
  mounted(){
    zhugeObj.track({
          title : '进入分享小游戏'
        })
      setTimeout(()=>{
      let shareBody = {
          desc: '包拯',
          title: '来，我给你变个魔法👇',
          imgUrl: 'https://img.chenzhen.shop/2022/03/16/96046194-6805-49ec-b054-eb0d46c0fd43.jpg',
          link : 'http://mi.baozheng.cc/bagGame'
        };
          wxShare(shareBody);
        },1000)
  },
  methods: {
    toKefu() {
      window.location.href="https://work.weixin.qq.com/kfid/kfcb79d59bdfa776e1d"
      zhugeObj.track({
          title : '点击分享小游戏-联系客服'
        })
    },

  }
}
</script>

<style>
.zjb_iframe{
  border: none;
  width: 100%;
  height: 80vh;
}
.configShare_bottom{
  width: 50%;
  position: fixed;
  bottom: 80px;
  left: 25%;
  height: 100px;
  background-color: transparent;
  padding-bottom: env(safe-area-inset-bottom);
}
.configShare_kefuBtn{
  width: 230px;
  height: 72px;
  box-sizing: border-box;
  padding-right: 40px;
  border-radius: 36px;
  color: white;
  text-align: right;
  line-height: 72px;
  display: block;
  margin: 0 auto;
  font-size: 28px;
  font-weight: 600;
  background: url('https://img.chenzhen.shop/2022/03/15/5514a9e3-9790-4845-9a8e-4ed409fe2ee8.jpg') no-repeat;
  background-position: 34px 16px;
  background-size: 38px;
  background-color: rgb(27,169,76);
}
.zjb_configShareTitle{
  font-size:28px;
  color: #982505;
  width: 100%;
  box-sizing: border-box;
  line-height: 40px;
  padding: 80px 100px 20px;
  text-align: center;
}
.zjb_configShareImgBox{
  width: 100%;
  box-sizing: border-box;
  padding: 0 40px;
}
.zjb_configShareImgBox img{
  display: block;
  width: 80%;
  margin: 0 auto 20px;
}
.zjb_configShareTitle2{
  font-size:28px;
  color: #982505;
  width: 100%;
  box-sizing: border-box;
  line-height: 44px;
  padding: 0 40px;
  margin-bottom: 40px;
  text-align: center;
}

</style>